module.exports = __webpack_public_path__ + "static/media/tool_logo_wpscan.92adc6c5.png";